export const NETWORK_ERROR = 'NETWORK_ERROR';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';

export const USERNAME_MISSING = 'USERNAME_MISSING';
export const PASSWORD_MISSING = 'PASSWORD_MISSING';
